import { ApiFormViewScaleOption } from "@/types/forms/form-view.types.ts";
import { useMemo } from "react";

export const useScaleDirection = (options: ApiFormViewScaleOption[] | undefined) => {
  const maxLength = 50;
  return useMemo(() => {
    if (!options || options.length === 0) return "horizontal";
    const total = options.reduce((sum, item) => sum + (item.title?.length || 0), 0) || 0;
    return total > maxLength ? "vertical" : "horizontal";
  }, [options]);
};
